module.exports = __webpack_public_path__ + "img/cloud-xl.99b4f575.png";